import { useState, useEffect } from 'react';
import { useMapsLibrary } from '@vis.gl/react-google-maps';
import { ProviderLocation, GeocodedMarker } from './types';
import {
  geocodeProviderLocations,
  getMarkerSize,
  getMarkerColor,
  getMarkerColorByProviderType,
} from './utils';

export const useClaimsMap = (providerLocations: ProviderLocation[]) => {
  const geocodingLib = useMapsLibrary('geocoding');
  const [markers, setMarkers] = useState<GeocodedMarker[]>([]);
  const [isGeocoding, setIsGeocoding] = useState(false);
  const [geocodingError, setGeocodingError] = useState<string | null>(null);

  // Geocode provider locations when geocoding library is loaded
  useEffect(() => {
    if (!geocodingLib || !providerLocations || providerLocations.length === 0) {
      setMarkers([]);
      return;
    }

    const geocodeLocations = async () => {
      setIsGeocoding(true);
      setGeocodingError(null);

      try {
        const geocoder = new geocodingLib.Geocoder();
        const geocodedMarkers = await geocodeProviderLocations(
          providerLocations,
          geocoder
        );
        setMarkers(geocodedMarkers);
      } catch (error) {
        console.error('Geocoding error:', error);
        setGeocodingError(
          error instanceof Error
            ? error.message
            : 'Failed to geocode provider locations'
        );
      } finally {
        setIsGeocoding(false);
      }
    };

    geocodeLocations();
  }, [geocodingLib, providerLocations]);


  return {
    markers,
    isGeocoding,
    geocodingError,
    getMarkerSize,
    getMarkerColor,
    getMarkerColorByProviderType,
  };
};
